import React from 'react'

import { DropdownItem } from 'reactstrap'
import cx from 'classnames'

import ButtonIcon from 'common/ButtonIcon'
import Dropdown from 'common/Dropdown'
import Icon from 'common/Icon'

export default ({ resource, onChange, defaultFilters }) => {
  const [filters, setFilters] = React.useState(defaultFilters)

  const handleFilterChange = value => {
    const newFilters = { ...filters, ...value }
    setFilters(newFilters)
    onChange(newFilters)
  }

  const isDate = filters.sort === 1
  const isAction = filters.sort === 2

  return (
    <div className="col-auto ms-auto d-flex align-items-start px-1">
      <ButtonIcon
        icon="folder_open"
        title={resource.OpenCases}
        disabled={!filters.isArchived}
        className={cx('mr-1', !filters.isArchived && 'active')}
        onClick={() => handleFilterChange({ isArchived: false })}
      />
      <ButtonIcon
        icon="inventory"
        title={resource.ClosedCases}
        disabled={filters.isArchived}
        className={cx('mr-1', filters.isArchived && 'active')}
        onClick={() => handleFilterChange({ isArchived: true })}
      />
      <Dropdown
        caret
        toggleButtonOptions={{
          icon: isAction ? 'thumb_up' : 'calendar_month',
          title: isAction ? resource.SortByAction : resource.SortByCreated,
          text: true,
        }}
      >
        <DropdownItem
          className="d-inline-flex align-items-center"
          active={isDate}
          onClick={() => handleFilterChange({ sort: 1 })}
        >
          <Icon icon="calendar_month" className="me-2" />
          {resource.SortByCreated}
        </DropdownItem>
        <DropdownItem
          className="d-inline-flex align-items-center"
          active={isAction}
          onClick={() => handleFilterChange({ sort: 2 })}
        >
          <Icon icon="thumb_up" className="me-2" />
          {resource.SortByAction}
        </DropdownItem>
      </Dropdown>
    </div>
  )
}
